import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sources } from '../api/sources';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { ErrorType } from '../shared/types';
import Spinner from '../components/Spinner';

const PaymentStatusPage: React.FC = () => {
  let navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [, setTransactionId] = useGlobalState('transactionId');
  const [, setTransactionProductPrefix] = useGlobalState('transactionProductPrefix');

  const getTransactionDetails = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const transactionId = urlParams.get('transactionId') || '';
      const transactionProductPrefix = urlParams.get('pp') || '';

      await sources.getTransactionStatus({ transactionId });
      setTransactionId(transactionId);
      setTransactionProductPrefix(transactionProductPrefix?.toUpperCase());
      setLoading(false);
      navigate(Pages.UpdateEmail);
    } catch (error: unknown) {
      setLoading(false);
      navigate(Pages.SorryPage, { state: { errorType: ErrorType.SYSTEM_ERROR } });
    }
  };

  useEffect(() => {
    getTransactionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isLoading ? (
    <Spinner />
  ) : (
    <></>
  );
};

export default PaymentStatusPage;
